import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "./services/cookies.service";
import { routes } from "./routes";

const ProtectedRoutes = ({ children }) => {
  const location = useLocation();
  const token = getCookie("token");
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  if (!token && !isLoggedIn) {
    return (
      <Navigate
        replace
        to={routes.HOME}
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default ProtectedRoutes;
